import { MediaAsset, MediaAssetType } from 'shared/@generated/models';

type MediaAssetWithVideoUrl = MediaAsset & {
  video_url?: string | null;
  video_fallback_url?: string | null;
};

export function getMediaAssetVideoUrl(mediaAsset: MediaAssetWithVideoUrl) {
  if (mediaAsset.type !== MediaAssetType.Video) {
    return mediaAsset.url;
  }

  return mediaAsset.video_url ?? mediaAsset.url;
}

export function getMediaAssetVideoPosterUrl(mediaAsset: MediaAssetWithVideoUrl) {
  if (mediaAsset.type !== MediaAssetType.Video) return undefined;

  if (/\.(?:m3u8|m4v|mov|mp4|ogv|webm)(?:$|[?#])/i.test(mediaAsset.url)) {
    return undefined;
  }

  return mediaAsset.url;
}

export function getMediaAssetVideoFallbackUrl(mediaAsset: MediaAssetWithVideoUrl) {
  return mediaAsset.type === MediaAssetType.Video ? mediaAsset.video_fallback_url : undefined;
}
